import { render } from "./TendencyCharacteristics.vue?vue&type=template&id=ebea3fe0"
import script from "./TendencyCharacteristics.vue?vue&type=script&lang=js"
export * from "./TendencyCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script